module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-imbee-header",
    style: ({
      color: _vm.color,
      fontSize: _vm.fontSize,
      fontWeight: _vm.fontWeight,
      fontFamily: _vm.fontFamily,
      backgroundColor: _vm.backgroundColor,
      boxShadow: ("0px -10px 12px 8px " + _vm.backgroundColor),
      marginTop: _vm.headerMarginTop,
      position: 'relative',
      top: _vm.headerTop,
      left: _vm.headerLeft
    })
  }, [(_vm.showImage) ? _c('img', {
    style: ({
      height: _vm.imageSize
    }),
    attrs: {
      "src": _vm.image,
      "alt": "Header image"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "w-imbee-header-subtitle",
    style: (_vm.subtitleStyles)
  }, [_vm._v("\n    " + _vm._s(_vm.subtitleText) + "\n  ")]), _vm._v(" "), (_vm.showCloseButton && !_vm.fullScreen) ? _c('div', {
    staticClass: "w-imbee-close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('Close', {
    attrs: {
      "width": "14px",
      "height": "14px"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4be6c8e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 212
// module chunks = 0 1